import api from 'api/axiosInstance';
import { getStoredWorkspaceId } from 'utils/workspaceStorage';

export enum AxiosMethod {
  GET = 'get',
  POST = 'post',
  PUT = 'put',
  PATCH = 'patch',
  DELETE = 'delete',
}

/**
 * GET with explicit x-on-behalf-of (e.g. Chift export polling).
 * x-workspace is left to axios default (stored workspace). Interceptor does not overwrite when already set.
 */
export function apiGetWithExpertContext<T = unknown>(
  url: string,
  context: { customerId: string },
): Promise<T> {
  return api.get(url, {
    headers: { 'x-on-behalf-of': context.customerId },
  }) as Promise<T>;
}

const apiWithWorkspaceHeader = (
  method: AxiosMethod,
  ...params: [string, any?, Record<string, unknown>?]
) => {
  const workspaceId = getStoredWorkspaceId();

  if (method === AxiosMethod.GET || method === AxiosMethod.DELETE) {
    const config = params[1] || {};
    const headers = {
      ...(workspaceId && { 'x-workspace': workspaceId }),
      ...(config.headers as Record<string, unknown>),
    };
    return api[method](params[0], { ...config, headers }) as Promise<any>;
  } else {
    const config = params[2] || {};
    const headers = {
      ...(workspaceId && { 'x-workspace': workspaceId }),
      ...(config.headers as Record<string, unknown>),
    };
    return api[method](params[0], params[1], {
      ...config,
      headers,
    }) as Promise<any>;
  }
};
export default apiWithWorkspaceHeader;
